import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationLog } from '../interfaces/application-log.interface';

@Injectable({
	providedIn: 'root',
})
export class ApplicationLogService {
	url: string = 'applicationLog';

	constructor(private http: HttpClient) {}

	public get(): Observable<ApplicationLog[]> {
		return this.http.get<ApplicationLog[]>(this.url);
	}

	public canView(): Observable<ApplicationLog> {
		return this.http.get<ApplicationLog>(this.url + '/canView');
	}
}
